export default __webpack_public_path__ + "static/media/OrderOffIcon.408b36d5.svg";